import { Box, FormHelperText } from '@mui/material';

const ErrorFrame = ({
    error,
    helperText,
    showHelperText,
    children,
    ...props
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    error?: boolean;
    helperText?: React.ReactNode;
    showHelperText?: boolean;
}) => {
    const shouldShowHelperText = Boolean(helperText && (error || showHelperText));

    return (
        <div {...props}>
            <Box
                sx={{
                    border: (theme) => (error ? `1px solid ${theme.palette.error.main}` : 'none'),
                    borderRadius: 1,
                }}
            >
                {children}
            </Box>
            {shouldShowHelperText ? (
                <FormHelperText className="mt-0" error={error}>
                    {helperText}
                </FormHelperText>
            ) : null}
        </div>
    );
};

export { ErrorFrame };
